import { render } from "./UnblockLogin.vue?vue&type=template&id=347357c3&ts=true"
import script from "./UnblockLogin.vue?vue&type=script&lang=ts"
export * from "./UnblockLogin.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__